import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";
import { FiChevronLeft, FiChevronRight } from "react-icons/fi";
import { useRef } from "react";

import "swiper/css";
import "./NewProducts.css";

import p1 from "../../assets/image/products/01.jpg";
import p2 from "../../assets/image/products/02.jpg";
import p3 from "../../assets/image/products/03.jpg";
import p4 from "../../assets/image/products/04.jpg";
import p5 from "../../assets/image/products/05.jpg";

const products = [
  { img: p1, title: "S3240-8T", desc: "8 x 1Gb RJ45, 4 x 10Gb SFP+, PicOS®, L2+ Managed Switch" },
  { img: p2, title: "S3240-24T", desc: "24 x 1Gb RJ45, 4 x 10Gb SFP+, PicOS®, L2+ Managed Switch" },
  { img: p3, title: "AP-N716", desc: "Wi-Fi 7, AmpCon, Three Radios, 2x2 MU-MIMO, Indoor" },
  { img: p4, title: "SFP-10G-T-30", desc: "10G SFP+ R9F85A 30m RJ-45 Module" },
  { img: p5, title: "QSFP-4×10G-SR", desc: "40G QSFP+ SR4 150m MPO-12/UPC Module" },
];

export default function NewProducts() {
  const prevRef = useRef(null);
  const nextRef = useRef(null);

  return (
    <section className="new-products-light">
      <h2 className="title">New Products</h2>

      <div className="slider-wrapper">
        {/* CUSTOM REACT ICON ARROWS */}
        <button ref={prevRef} className="nav-arrow prev" aria-label="Previous">
          <FiChevronLeft />
        </button>

        <button ref={nextRef} className="nav-arrow next" aria-label="Next">
          <FiChevronRight />
        </button>

        <Swiper
          modules={[Navigation]}
          spaceBetween={24}
          slidesPerView={4}
          onBeforeInit={(swiper) => {
            swiper.params.navigation.prevEl = prevRef.current;
            swiper.params.navigation.nextEl = nextRef.current;
          }}
          navigation={{
            prevEl: prevRef.current,
            nextEl: nextRef.current,
          }}
          breakpoints={{
            0: { slidesPerView: 1 },
            576: { slidesPerView: 2 },
            768: { slidesPerView: 3 },
            1200: { slidesPerView: 4 },
          }}
          className="product-swiper"
        >
          {products.map((item, index) => (
            <SwiperSlide key={index}>
              <div className="product-card">
                <div className="img-box">
                  <img src={item.img} alt={item.title} />
                </div>
                <h6>{item.title}</h6>
                <p>{item.desc}</p>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </section>
  );
}